import Container from "@mui/material/Container";
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import Header from "../headers/Header";
import { useState, useEffect } from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import GrandPrixOverview from '../dataDisplay/stats/GrandPrixOverview';
import GrandPrixRaces from '../dataDisplay/stats/GrandPrixRaces';
import LoadingShells from '../utilComponents/LoadingShells';
import SearchBar from "../utilComponents/SearchBar";
import ScoreProgressChart from '../dataDisplay/stats/grandPrix/ScoreProgressChart';
import EloProgressChart from '../dataDisplay/stats/grandPrix/EloProgressChart';
import { playerColors } from '../utils/PlayerColorUtils';

import { fetchWithRetry } from '../utils/ApiHelper'

const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL;

function toTitleCase(str) {
    return str.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
        return match.toUpperCase();
    });
}

const StatsGrandPrix = () => {
    const params = useParams()
    const [grandPrixData, setGrandPrixData] = useState(null);
    const [playerColorMap, setPlayerColorMap] = useState({});

    const [selectedTab, setSelectedTab] = useState(0);
    const [loading, setLoading] = useState(true); // State for loading spinner

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const renderTabContent = () => {
        switch (selectedTab) {
            case 0:
                return grandPrixData ? <GrandPrixOverview records={grandPrixData.playerFinishRecords} places={grandPrixData.finalPlaceRecords} /> : <p>No Data Available</p>;
            case 1:
                return grandPrixData ? (
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <ScoreProgressChart data={grandPrixData.scoreChartRecords} playerColorMap={playerColorMap} />
                        
                        <Box sx={{ borderTop: '1px solid #e0e0e0', width: '100%' }}></Box>
                        
                        <EloProgressChart data={grandPrixData.eloChartRecords} playerColorMap={playerColorMap} />
                        {/* <PlaceProgressChart data={grandPrixData.raceRecords} playerColorMap={playerColorMap} /> */}
                    </Box>
                ) : <p>No Data Available</p>;
            case 2:
                return grandPrixData ? <GrandPrixRaces raceRecords={grandPrixData.raceRecords} /> : <p>No Data Available</p>;
            default:
                return null;
        }
    };

    useEffect(() => {
        const getGrandPrixStats = async () => {
            setGrandPrixData(null);
            setLoading(true);
            const results = await fetchWithRetry(
                `${process.env.REACT_APP_STATS_BACKEND_ADDRESS || "/api/stats"}/grand_prix/${params.id}`,
                {
                    headers: { "accepts": "application/json" },
                    method: "GET"
                }
            );
            const data = await results.json();
            const colorMap = {};
            const playerIds = new Set();

            data.scoreChartRecords?.forEach(record => {
                playerIds.add(record.playerId);
            });
            data.eloChartRecords?.forEach(record => {
                playerIds.add(record.playerId);
            });
            Array.from(playerIds).forEach((playerId, colorIndex) => {
                colorMap[playerId] = playerColors[colorIndex % playerColors.length];
            });

            setPlayerColorMap(colorMap);
            setGrandPrixData(data);
            setLoading(false);
        };

        getGrandPrixStats();
    }, [params.id]);

    return (
        <Container
            component="main"
            sx={{
                marginTop: 4,
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
            {loading ? (
                <LoadingShells/>
            ) : (<>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    sx={{ p: 1 }}>
                    <Header src={`${IMAGE_URL}headers/Stats.png`} alt="Stats Title" />
                </Box>
                <SearchBar grandPrixList={JSON.parse(localStorage.getItem("apiGrandPrixListV2"))} playerList={JSON.parse(localStorage.getItem("apiRosterV2"))}/>
                <Box
                    sx={{
                        mb: 2,
                        width: '300px',
                        textAlign: 'center',
                        color: 'black', // Text color
                        // borderRadius: 2,
                        // border: 3,
                        // boxShadow: 6
                    }}
                >
                    <Typography variant="h6" sx={{ fontFamily: '"Press Start 2P", sans-serif', fontWeight: 'bold', fontSize: '1rem' }}>{grandPrixData.generalInformation.title}</Typography>
                </Box>

                <Box
                    sx={{
                        margin: 'auto',
                        textAlign: 'center',
                    }}
                >
                    <Typography sx={{ marginBottom: 1, fontFamily: '"Press Start 2P", sans-serif', fontSize: '.75rem' }}>
                        <strong>Date:</strong> {new Date(grandPrixData.generalInformation.createDate).toLocaleDateString()}
                    </Typography>
                    <Typography sx={{ marginBottom: 1, fontFamily: '"Press Start 2P", sans-serif', fontSize: '.75rem' }}>
                        <strong>Rule:</strong> {toTitleCase(grandPrixData.generalInformation.rule)}
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 3, textAlign: 'center', justifyContent: 'center' }}>
                        <Typography sx={{ marginBottom: 1, fontFamily: '"Press Start 2P", sans-serif', fontSize: '.75rem' }}>
                            {grandPrixData.generalInformation.hardcore ? 'Hardcore' : 'Normal'}
                        </Typography>
                        <Typography sx={{ marginBottom: 1, fontFamily: '"Press Start 2P", sans-serif', fontSize: '.75rem' }}>
                            {grandPrixData.generalInformation.engineClass}
                        </Typography>
                    </Box>
                </Box>


                <Box sx={{ marginTop: 1 }}>
                    <Tabs
                        value={selectedTab}
                        onChange={handleTabChange}
                        centered
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label="Results" />
                        <Tab label="Charts" />
                        <Tab label="Races" />
                    </Tabs>
                    <Box align='center' sx={{ display: 'flex', justifyContent: 'center', width: "100vw" }}>
                        {renderTabContent()}
                    </Box>
                </Box>
            </>)}
        </Container>

    )
}

export default StatsGrandPrix;
